import { tns } from "../../../node_modules/tiny-slider/src/tiny-slider"

$(document).ready(function () {
    var sliderEl = document.querySelector('.tiny-slider')
    if (!sliderEl) {
        return
    }
    var slider = tns({
        container: '.tiny-slider',
        slideBy: 'page',
        center: true,
        gutter: 25,
        fixedWidth: 250,
        swipeAngle: false,
        controls: false,
        nav: false,
        preventScrollOnTouch: 'auto'
    });
})